import { render, staticRenderFns } from "./BreadCrumbItem.vue?vue&type=template&id=18eae577&scoped=true"
import script from "./BreadCrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadCrumbItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eae577",
  null
  
)

export default component.exports